<template>
	<el-dialog class="worksDetailsDialog" :visible="show" append-to-body @close="handleClose" @open="goodsDetails">
		<div slot="title">
			<div class="dislogTitle">
			</div>
		</div>
		<div class="dislogConent">
			<img class="invoiceImg" :src="goods.img" v-if="goods.img" />
			<div class="contentRight">
				<div class="name">{{goods.title ? goods.title : ''}}</div>
				<div class="attributes">
					<div class="attributeItem ellipsis-1">
						资源类型：{{goods.top_title ? goods.top_title : ''}}
					</div>
					<div class="attributeItem ellipsis-1">
						材质类别：{{goods.cid ? goods.cid : ''}}
					</div>
				</div>
				<div class="attributes">
					<div class="attributeItem ellipsis-1">
						兑换说明：{{goods.level && goods.level != 0 ? `支持${goods.level.join(',')}兑换` : '不支持会员兑换'}}
					</div>
				</div>
				<div class="tips" v-if="goods.gjz && goods.gjz.length">
					<div class="tip" v-for="(item,index) in goods.gjz" :key="index">{{item}}</div>
				</div>
				<div class="technologyBox">
					<div class="technologyTitle">
						技术信息
					</div>
					<div class="technologyItem">
						方法：{{goods.fangfa ? goods.fangfa : ''}}
					</div>
					<div class="technologyItem">
						格式：{{goods.geshi ? goods.geshi : ''}}
					</div>
					<div class="technologyItem">
						实际大小：{{goods.daxiao ? goods.daxiao : ''}}
					</div>
				</div>
				<div class="integralNum">{{goods.original_price ? goods.original_price : '0'}}积分</div>
				<div class="exchangeMenuBox">
					<div class="integralExchange" :class="isBuy == 1 ? 'integralExchangeNor' : 'integralExchangeSel'"
						@click="exchangeGoogs(1)">积分兑换</div>
					<div class="levelExchange" :class="isBuy == 1 ? 'levelExchangeNor' : 'levelExchangeSel'"
						@click="exchangeGoogs(2)">会员兑换</div>
				</div>
				<div class="collectionBox" :class="goods.is_sc && goods.is_sc == 1 ? 'collectioned' : 'noCollection'"
					@click="collectionGoods">
					<img class="icon" src="../assets/Register/collectNor.png" v-if="goods.is_sc && goods.is_sc == 1" />
					<img class="icon" src="../assets/Register/collectSel.png" v-else />
					{{goods.is_sc && goods.is_sc == 1 ? '已收藏' : '收藏作品'}}
				</div>
				<div class="menuBox">
					<div class="look" @click="lookHdImg" v-if="goods.top_title && goods.top_title == '材质'">
						<img class="icon" src="../assets/Register/look.png" />
						高清大图
					</div>
					<div class="look" @click="downloadSbsar" v-if="goods.top_title && goods.top_title == '材质'">
						<img class="icon" src="../assets/Register/workType.png" />
						SBSAR格式文件
					</div>
					<div class="look" @click="lookThreedimensional" v-if="goods.top_title && goods.top_title == '模型'">
						<img class="icon" src="../assets/Register/look.png" />
						3D效果查看
					</div>
					<div class="look" @click="downThreedimensional" v-if="goods.top_title && goods.top_title == '模型'">
						<img class="icon" src="../assets/Register/workType.png" />
						3D文件下载
					</div>
				</div>
			</div>
		</div>
		<div slot="footer">
			<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'您已完成作品兑换，可到个人中心'"
				:descTwo="'我的作品模块查看'"
				@clickOk="sucPop = false;$router.push(`/personal-center?menuId=3&activeCategory=${goods.top_title == '材质' ? '1' : '2'}`)"
				v-if="sucPop" />
			<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="desc" :descTwo="descTwo"
				@clickOk="failPop = false;" v-if="failPop" />
			<ThreeDimensionalDialog :show="dialog3DVisible" @close="dialog3DVisible = false;"
				:objFileUrl="dialog3DVisible ? goods.obj_file : ''" />
			<LookDetailsDialog :show="dialogReportVisible" :data="{img: goods.gq_img}"
				@close="dialogReportVisible = false" />
		</div>
	</el-dialog>
</template>

<script>
	import ThreeDimensionalDialog from '../components/ThreeDimensionalDialog.vue'
	import LookDetailsDialog from '../components/LookDetailsDialog.vue'
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			goodsId: {
				type: [String, Number],
				default: '',
			},
			isBuy: {
				type: [String, Number],
				default: 0,
			},
		},
		components: {
			LookDetailsDialog,
			ThreeDimensionalDialog
		},
		data() {
			return {
				goods: {},
				desc: '',
				descTwo: '',
				sucPop: false,
				failPop: false,
				dialog3DVisible: false,
				dialogReportVisible: false,
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
				this.goods = {}
			},
			goodsDetails() {
				console.log(this.isBuy, this.isBuy == 1)
				this.$api.post(this.isBuy == 1 ? 'Order/goods_details' : '/Goods/goods_details', {
					user_id: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
					goods_id: this.goodsId
				}).then(result => {
					if (result.code == 1) {
						this.goods = result.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			collectionGoods() {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/sc_work', {
						id: this.goodsId
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.$emit('updateData')
							this.goodsDetails()
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			async downloadImages(url) {
				try {
					// 使用 fetch 获取原图 Blob
					const response = await fetch(url, {
						mode: 'cors'
					});
					const blob = await response.blob();

					// 创建临时 a 标签下载
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = this.getFileNameFromUrl(url); // 使用原始文件名
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					// 释放对象 URL
					URL.revokeObjectURL(link.href);
				} catch (err) {
					console.error('下载失败', url, err);
				}
			},
			getFileNameFromUrl(url) {
				return url.substring(url.lastIndexOf('/') + 1);
			},
			exchangeGoogs(type) {
				if (localStorage.getItem('token')) {
					if (this.isBuy == 1) return
					this.$api.post('/Order/order_add', {
						id: this.goodsId,
						pay_type: type
					}).then(res => {
						if (res.code == 1) {
							this.sucPop = true
							this.$emit('updateData')
						} else {
							if (res.msg == '积分不足') {
								this.desc = '您的兑换积分不足，请进行积分充'
								this.descTwo = '值后再下载'
							} else if (res.msg == '仅支持积分兑换') {
								this.desc = '您好，当前作品不支持会员下载，'
								this.descTwo = '仅可积分兑换！'
							} else if (res.msg == '非会员次数不足') {
								this.desc = '您好，您当前为非会员身份，不支持'
								this.descTwo = '会员兑换'
							} else if (res.msg == '非会员无权限') {
								this.desc = '您好，您当前为非会员身份，不支持'
								this.descTwo = '会员兑换'
							} else if (res.msg == '会员次数不足') {
								this.desc = '尊敬的会员，您好。您已达到每日'
								this.descTwo = '最大可兑换资源次数限制，请明日再进行兑换'
							} else if (res.msg == '会员无权限') {
								this.desc = '您好，您当前会员身份不支持'
								this.descTwo = '下载'
							}
							this.failPop = true
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			lookHdImg() {
				if (localStorage.getItem('token')) {
					if (this.isBuy == 1) {
						this.dialogReportVisible = true
					} else {
						this.desc = '作品完成兑换后，方可点击查看高'
						this.descTwo = '清大图。'
						this.failPop = true
					}
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			downloadSbsar() {
				if (localStorage.getItem('token')) {
					if (this.isBuy == 1) {
						if (window.innerWidth <= 480) return this.$message.warning('请到电脑端登录操作')
						this.downloadImages(this.goods.obj_file)
					} else {
						this.desc = '您好，您当前暂无下载权限，请先'
						this.descTwo = '兑换作品后，再进行操作'
						this.failPop = true
					}
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			lookThreedimensional() {
				this.dialog3DVisible = true
			},
			downThreedimensional() {
				if (localStorage.getItem('token')) {
					if (this.isBuy == 1) {
						if (window.innerWidth <= 480) return this.$message.warning('请到电脑端登录操作')
						this.downloadImages(this.goods.obj_file)
					} else {
						this.desc = '您好，您当前暂无下载权限，请先'
						this.descTwo = '兑换作品后，再进行操作'
						this.failPop = true
					}
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			submitForm() {
				const userIds = this.fanSiData.filter(item => item.check).map(item => item.user_id)
				if (userIds.length == 0) {
					return this.$message.warning('请添加群成员')
				}
				this.$api.post('/Liaotian/add_group_user', {
					user_id: userIds.join(','),
					gid: this.gid
				}).then(result => {
					if (result.code == 1) {
						this.$emit('addFansSuc')
						this.handleClose()
					} else {
						this.$message.error(result.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width: 480px) {
		.worksDetailsDialog {

			::v-deep .el-dialog {
				width: 11.84rem;
				border-radius: .08rem;
				border-radius: .12rem;
				background: rgba(31, 32, 39, 1);
				margin-top: unset !important;

				.dislogTitle {
					height: .88rem;
				}

				&__headerbtn {
					top: .12rem;
					right: .3rem;
					font-size: .48rem;
				}

				&__header {
					padding: 0 0;
				}

				&__body {
					padding: 0 .6rem;
				}

				&__footer {
					padding: 0 .6rem .54rem;
				}
			}
		}

		.dislogConent {
			display: flex;
			flex-direction: column;

			.invoiceImg {
				width: 11.2rem;
				height: 11.2rem;
				object-fit: cover;
			}

			.contentRight {
				display: flex;
				flex-direction: column;

				.name {
					margin-top: .24rem;
					font-weight: 500;
					font-size: .48rem;
					color: #FFFFFF;
					line-height: .72rem;
				}

				.attributes {
					margin-top: .24rem;
					display: flex;
					align-items: center;

					.attributeItem {
						margin-right: .48rem;
						font-weight: 400;
						font-size: .28rem;
						color: #FFFFFF;
						line-height: .44rem
					}
				}

				.tips {
					margin-top: .32rem;
					display: flex;
					flex-wrap: wrap;

					.tip {
						margin-right: .32rem;
						display: flex;
						align-items: center;
						height: .52rem;
						border-radius: .26rem;
						padding: 0 .16rem;
						border: .01rem solid rgba(255, 255, 255, .3);
						font-size: .24rem;
						color: #ADADAD;
						line-height: .36rem;
					}
				}

				.technologyBox {
					margin-top: .4rem;
					display: flex;
					flex-direction: column;
					width: 8.9rem;
					background: rgba(255, 255, 255, .08);
					border-radius: .12rem;
					padding: .24rem .32rem;

					.technologyTitle {
						font-weight: 700;
						font-size: .28rem;
						color: #FFFFFF;
						line-height: .44rem;
					}

					.technologyItem {
						font-weight: 400;
						font-size: .28rem;
						color: rgba(255, 255, 255, .5);
						line-height: .44rem;
					}
				}

				.integralNum {
					margin-top: .4rem;
					font-weight: 700;
					font-size: .48rem;
					color: #98E83E;
					line-height: .64rem;
				}

				.exchangeMenuBox {
					margin-top: .4rem;
					display: flex;
					align-items: center;

					.integralExchange,
					.levelExchange {
						margin-right: .32rem;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 3.84rem;
						height: 1.04rem;
						border-radius: .52rem;
						font-weight: 500;
						font-size: .3rem;
						line-height: .64rem;
						cursor: pointer;
					}

					.integralExchangeSel {
						color: #FFFFFF;
						background: rgba(22, 115, 230, 1);
					}

					.levelExchangeSel {
						color: rgba(152, 232, 62, 1);
						border: .01rem solid #98E83E;
					}

					.integralExchangeNor {
						color: rgba(255, 255, 255, .6);
						background: rgba(255, 255, 255, .08);
					}

					.levelExchangeNor {
						color: rgba(255, 255, 255, .6);
						border: .01rem solid rgba(48, 49, 55, 1);
					}
				}

				.collectionBox {
					margin-top: .32rem;
					display: flex;
					align-self: start;
					align-items: center;
					font-size: .28rem;
					line-height: 44px;
					cursor: pointer;

					.icon {
						margin-right: .32rem;
						width: .92rem;
						height: .92rem;
					}
				}

				.collectioned {
					color: #999999;
				}

				.noCollection {
					color: rgba(22, 115, 230, 1);
				}

				.menuBox {
					margin-top: .24rem;
					display: flex;
					align-items: center;

					.look {
						margin-right: .48rem;
						display: flex;
						align-items: center;
						justify-content: center;
						height: 1.12rem;
						padding: 0 .32rem;
						border: .01rem solid rgba(151, 151, 151, .4);
						font-size: .28rem;
						color: #FFFFFF;
						line-height: .28rem;
						cursor: pointer;

						.icon {
							margin-right: .12rem;
							width: .36rem;
							height: .36rem;
						}
					}
				}
			}
		}
	}

	@media (min-width: 481px) {
		.worksDetailsDialog {

			::v-deep .el-dialog {
				width: 11.84rem;
				border-radius: .08rem;
				border-radius: .12rem;
				background: rgba(31, 32, 39, 1);

				.dislogTitle {
					height: .44rem;
				}

				&__headerbtn {
					top: .12rem;
					right: .3rem;
					font-size: .24rem;
				}

				&__header {
					padding: 0 0;
				}

				&__body {
					padding: 0 .6rem;
				}

				&__footer {
					padding: 0 .6rem .54rem;
				}
			}
		}

		.dislogConent {
			display: flex;

			.invoiceImg {
				width: 5.6rem;
				height: 5.6rem;
				object-fit: cover;
			}

			.contentRight {
				margin-left: .6rem;
				display: flex;
				flex-direction: column;

				.name {
					margin-top: .12rem;
					font-weight: 500;
					font-size: .24rem;
					color: #FFFFFF;
					line-height: .36rem;
				}

				.attributes {
					margin-top: .12rem;
					display: flex;
					align-items: center;

					.attributeItem {
						margin-right: .24rem;
						font-weight: 400;
						font-size: .14rem;
						color: #FFFFFF;
						line-height: .22rem
					}
				}

				.tips {
					margin-top: .16rem;
					display: flex;
					flex-wrap: wrap;

					.tip {
						margin-right: .16rem;
						display: flex;
						align-items: center;
						height: .26rem;
						border-radius: .13rem;
						padding: 0 .08rem;
						border: .01rem solid rgba(255, 255, 255, .3);
						font-size: .12rem;
						color: #ADADAD;
						line-height: .18rem;
					}
				}

				.technologyBox {
					margin-top: .2rem;
					display: flex;
					flex-direction: column;
					width: 4.45rem;
					background: rgba(255, 255, 255, .08);
					border-radius: .06rem;
					padding: .12rem .16rem;

					.technologyTitle {
						font-weight: 700;
						font-size: .14rem;
						color: #FFFFFF;
						line-height: .22rem;
					}

					.technologyItem {
						font-weight: 400;
						font-size: .14rem;
						color: rgba(255, 255, 255, .5);
						line-height: .22rem;
					}
				}

				.integralNum {
					margin-top: .2rem;
					font-weight: 700;
					font-size: .24rem;
					color: #98E83E;
					line-height: .32rem;
				}

				.exchangeMenuBox {
					margin-top: .2rem;
					display: flex;
					align-items: center;

					.integralExchange,
					.levelExchange {
						margin-right: .16rem;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 1.92rem;
						height: .52rem;
						border-radius: .26rem;
						font-weight: 500;
						font-size: .15rem;
						line-height: .32rem;
						cursor: pointer;
					}

					.integralExchangeSel {
						color: #FFFFFF;
						background: rgba(22, 115, 230, 1);
					}

					.levelExchangeSel {
						color: rgba(152, 232, 62, 1);
						border: .01rem solid #98E83E;
					}

					.integralExchangeNor {
						color: rgba(255, 255, 255, .6);
						background: rgba(255, 255, 255, .08);
					}

					.levelExchangeNor {
						color: rgba(255, 255, 255, .6);
						border: .01rem solid rgba(48, 49, 55, 1);
					}
				}

				.collectionBox {
					margin-top: .32rem;
					display: flex;
					align-self: start;
					align-items: center;
					font-size: .14rem;
					line-height: 22px;
					cursor: pointer;

					.icon {
						margin-right: .16rem;
						width: .46rem;
						height: .46rem;
					}
				}

				.collectioned {
					color: #999999;
				}

				.noCollection {
					color: rgba(22, 115, 230, 1);
				}

				.menuBox {
					margin-top: .24rem;
					display: flex;
					align-items: center;

					.look {
						margin-right: .24rem;
						display: flex;
						align-items: center;
						justify-content: center;
						height: .56rem;
						padding: 0 .16rem;
						border: .01rem solid rgba(151, 151, 151, .4);
						font-size: .14rem;
						color: #FFFFFF;
						line-height: .14rem;
						cursor: pointer;

						.icon {
							margin-right: .06rem;
							width: .18rem;
							height: .18rem;
						}
					}
				}
			}
		}
	}
</style>